import { AddonFragment, PackageStatus, PlanFragment } from '@stigg-types/apiTypes';

export const isDraftPackage = (aPackage: PlanFragment | AddonFragment) =>
  !!(aPackage.draftDetails && aPackage.isLatest && aPackage.status === PackageStatus.Published);

export const isOutdatedPackage = (aPackage: PlanFragment | AddonFragment) =>
  !!(!aPackage.isLatest && aPackage.status === PackageStatus.Published);
